import { render } from "./CheckboxForClass.vue?vue&type=template&id=e3e35f32&scoped=true&ts=true&lang=pug"
import script from "./CheckboxForClass.vue?vue&type=script&lang=ts"
export * from "./CheckboxForClass.vue?vue&type=script&lang=ts"

import "./CheckboxForClass.vue?vue&type=style&index=0&id=e3e35f32&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3e35f32"]])

export default __exports__